var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOurCasestudyPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9903 43.3817C49.0913 43.1372 49.0913 42.8626 48.9903 42.618C48.9415 42.4968 48.8695 42.3863 48.7782 42.2928L41.7071 35.2217C41.5196 35.0342 41.2652 34.9288 41 34.9288C40.7348 34.9288 40.4804 35.0342 40.2929 35.2217C40.1054 35.4092 40 35.6636 40 35.9288C40 36.194 40.1054 36.4484 40.2929 36.6359L45.6598 42.0029L33.9289 41.9958C33.7969 41.9952 33.6661 42.0208 33.5441 42.0711C33.422 42.1214 33.3111 42.1953 33.2177 42.2887C33.1244 42.382 33.0504 42.4929 33.0002 42.615C32.9499 42.7371 32.9243 42.8679 32.9249 42.9999C32.9243 43.1319 32.9499 43.2627 33.0002 43.3848C33.0504 43.5068 33.1244 43.6177 33.2177 43.7111C33.3111 43.8044 33.422 43.8784 33.5441 43.9286C33.6661 43.9789 33.7969 44.0045 33.9289 44.004L45.6598 43.9969L40.2929 49.3638C40.1054 49.5514 40 49.8057 40 50.0709C40 50.3362 40.1054 50.5905 40.2929 50.7781C40.4804 50.9656 40.7348 51.0709 41 51.0709C41.2652 51.0709 41.5196 50.9656 41.7071 50.7781L48.7782 43.707C48.8695 43.6135 48.9415 43.503 48.9903 43.3817V43.3817Z",
    fill: "#12171D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(41 26.0293) rotate(45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurCasestudyPlay);
export default __webpack_public_path__ + "static/media/our_casestudy_play.e8b793e5cb4dc7a973d60b08a5d3ed62.svg";
export { ForwardRef as ReactComponent };